import { hardRefreshPage, openGmailToAskForHelp } from './internal/actions';
import GenericErrorPage from './internal/generic-error-page';

export const UnhandledExceptionScreen = ({error}: {error: Error}) => {
  console.error(error);

  return (
  <GenericErrorPage
    title="Server Error"
    message="Something went wrong on our end. Try refreshing the page. If the issue persists, please reach out to our support team."
    primaryCTA={{
      title: 'Reload Page',
      action: hardRefreshPage
    }}
    secondaryCTA={{
      title: "Contact Support",
      action: () => openGmailToAskForHelp()
    }}
  />);
  }